export default __webpack_public_path__ + "static/national-digifoundry-logo-0f30432f70abfcd38e591ca32592525d.png";